import { Dialog, DialogContent, DialogTitle } from "@/components/ui/dialog";
import { BookOpen } from "lucide-react";
import { API } from "@/lib/api";

export function PdfViewer({ open, onClose, resourceId, page, pdfPage, title }) {
  // The httpOnly auth cookie is sent automatically with the same-origin iframe request.
  // pdfPage is the actual page inside the PDF file; `page` is the printed page shown to staff.
  const target = pdfPage || page || 1;
  const src = resourceId
    ? `${API}/resources/${resourceId}/download#page=${target}&view=FitH`
    : null;
  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="h-[90vh] w-[95vw] max-w-5xl p-0" data-testid="pdf-viewer-dialog">
        <DialogTitle className="flex items-center gap-2 border-b border-border px-4 py-3 font-heading text-sm font-bold text-foreground">
          <BookOpen className="h-4 w-4 text-sky-600" />
          {title}
          {page && <span className="font-mono-c text-xs font-normal text-muted-foreground">· page {page}</span>}
        </DialogTitle>
        {src && (
          <iframe title="reference-pdf" src={src} className="h-full w-full rounded-b-lg" data-testid="pdf-viewer-frame" />
        )}
      </DialogContent>
    </Dialog>
  );
}
